
import React, { useEffect, useState, useCallback, useRef } from "react";
import Api from "../Utills/Api.js";
import Footer from "../Home/Footer";
import Navbar from "../Home/Navbar";
import { useNavigate } from "react-router-dom";
import useRazorpay from "react-razorpay";
import logo from "../../Frozenwala.png";
import { motion } from "framer-motion";
import "./Checkout.css";
import { toast } from "react-toastify";

const CheckoutPage = () => {
  const navigate = useNavigate();
  const [Razorpay] = useRazorpay();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // STATES
  const [deliveryOption, setDeliveryOption] = useState("delivery");
  const [selectedPickup, setSelectedPickup] = useState("Within 1hr");
  const [selectedOption, setSelectedOption] = useState("Within 1hr");
  const [getProduct, setGetProduct] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("online");
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [transactionCharge, setTransactionCharge] = useState(0);

  // PINCODE VALIDATION STATES
  const [pincodeCheck, setPincodeCheck] = useState("");
  const [pincodeValid, setPincodeValid] = useState(false);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [pincodeChecked, setPincodeChecked] = useState(false);
  const [selectedAddressPincodeValid, setSelectedAddressPincodeValid] = useState(false);
  const [checkingSelectedAddress, setCheckingSelectedAddress] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [pincodeDeliveryCharge, setPincodeDeliveryCharge] = useState(0);
  const [pincodeMessage, setPincodeMessage] = useState("");
  const [verifiedPincode, setVerifiedPincode] = useState("");

  // EDIT ADDRESS STATES
  const [editingAddressId, setEditingAddressId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  // Recalculate when payment method changes
  useEffect(() => {
    if (paymentMethod === "cod") {
      setTransactionCharge(0);
    } else {
      getTotalPrice();
    }
    setTimeout(() => {
      calculateFinalPrice();
    }, 100);
  }, [paymentMethod]);

  const fetchCustomerAddresses = async () => {
    try {
      const response = await Api.get(`api/addresses/?user_id=${uid}`);
      if (response?.data && response?.data?.length > 0) {
        setAddresses(response?.data);
      } else {
        setAddresses([]);
      }
    } catch (error) {
      console.log("Address fetch error:", error);
      setAddresses([]);
    }
  };

  const fetchPaymentOptions = async () => {
    try {
      const response = await Api.get("api/payment-options/");
      if (response?.data && response?.data?.length > 0) {
        setPaymentOptions(response?.data);
      }
    } catch (error) {
      console.log("Payment options error:", error);
    }
  };

  // COUPONS
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const [loadingCoupons, setLoadingCoupons] = useState(false);

  // PURCHASE BENEFITS
  const [purchaseBenefits, setPurchaseBenefits] = useState([]);
  const [loadingBenefits, setLoadingBenefits] = useState(false);

  // PRICE STATES
  const [baseTotal, setBaseTotal] = useState(0);
  const [previousPrice, setPreviousPrice] = useState(0);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);

  // GST STATES
  const [totalGstAmount, setTotalGstAmount] = useState(0);
  const [gstPercentage, setGstPercentage] = useState(0);
  const [cgstAmount, setCgstAmount] = useState(0);
  const [sgstAmount, setSgstAmount] = useState(0);

  // WALLET
  const wallet = Number(localStorage.getItem("wallet") || 0);
  const [walletValue, setWalletValue] = useState(0);
  const [walletBalance, setWalletBalance] = useState(wallet);

  // COUPON INPUT
  const [couponCode, setCouponCode] = useState("");
  const [couponApply, setCouponApply] = useState(false);
  const [pickup, setPickup] = useState(0);

  const uid = localStorage.getItem("user_id");

  const [addressInfo, setAddressInfo] = useState({
    name: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zip: "",
  });

  const [selectedAddressId, setSelectedAddressId] = useState(null);

  // Refs to prevent unnecessary re-renders
  const isUpdatingAddress = useRef(false);

  const checkPincode = async (pincodeToCheck, isForSelectedAddress = false) => {
    if (!pincodeToCheck || pincodeToCheck.length !== 6) {
      if (!isForSelectedAddress) {
        toast.error("Please enter a valid 6-digit pincode");
      }
      return false;
    }

    if (isForSelectedAddress) {
      setCheckingSelectedAddress(true);
    } else {
      setPincodeLoading(true);
    }

    try {
      const response = await Api.post("api/check_pincode/", {
        pincode: pincodeToCheck,
      });

      console.log("Pincode response:", response.data);

      if (
        response.data &&
        response.data.success === true &&
        response.data.available === true
      ) {
        const deliveryChargeAmount = response.data.delivery_charge || 0;
        const message = response.data.message || "Delivery available";

        if (!isForSelectedAddress) {
          setPincodeValid(true);
          setPincodeDeliveryCharge(deliveryChargeAmount);
          setPincodeMessage(message);
          setVerifiedPincode(pincodeToCheck);
          setPincodeChecked(true);
          setDeliveryCharge(deliveryChargeAmount);
          toast.success(message);
        } else {
          setSelectedAddressPincodeValid(true);
          setDeliveryCharge(deliveryChargeAmount);
          toast.success("Delivery available for this address!");
        }
        return true;
      } else {
        const errorMessage =
          response.data?.message || "Delivery not available for this pincode";

        if (!isForSelectedAddress) {
          setPincodeValid(false);
          setPincodeDeliveryCharge(0);
          setPincodeMessage(errorMessage);
          setVerifiedPincode("");
          setPincodeChecked(true);
          if (!selectedAddressPincodeValid) {
            setDeliveryCharge(0);
          }
          toast.error(errorMessage);
        } else {
          setSelectedAddressPincodeValid(false);
          setDeliveryCharge(0);
          toast.error(errorMessage);
        }
        return false;
      }
    } catch (error) {
      console.error("Pincode check error:", error);

      let errorMessage = "Failed to verify pincode. Please try again.";

      if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;

        if (!isForSelectedAddress) {
          setPincodeValid(false);
          setPincodeDeliveryCharge(0);
          setPincodeMessage(errorMessage);
          setVerifiedPincode("");
          setPincodeChecked(true);
          if (!selectedAddressPincodeValid) {
            setDeliveryCharge(0);
          }
        } else {
          setSelectedAddressPincodeValid(false);
          setDeliveryCharge(0);
        }
      } else {
        if (!isForSelectedAddress) {
          setPincodeValid(false);
          setPincodeDeliveryCharge(0);
          setPincodeMessage(errorMessage);
          setVerifiedPincode("");
          setPincodeChecked(true);
          if (!selectedAddressPincodeValid) {
            setDeliveryCharge(0);
          }
        } else {
          setSelectedAddressPincodeValid(false);
          setDeliveryCharge(0);
        }
      }

      toast.error(errorMessage);
      return false;
    } finally {
      if (isForSelectedAddress) {
        setCheckingSelectedAddress(false);
      } else {
        setPincodeLoading(false);
      }
    }
  };

  const handleSelectAddress = async (address) => {
    if (!address.zip_code || address.zip_code.length !== 6) {
      toast.error("Invalid pincode in selected address");
      setSelectedAddressId(null);
      setSelectedAddressPincodeValid(false);
      setDeliveryCharge(0);
      return;
    }

    setSelectedAddressId(address.id);
    setShowAddressForm(false);
    setIsEditing(false);
    setEditingAddressId(null);
    setShowEditModal(false);

    setSelectedAddressPincodeValid(false);

    const isValid = await checkPincode(address.zip_code, true);

    if (!isValid) {
      setSelectedAddressId(null);
      setDeliveryCharge(0);
    }
  };

  // EDIT ADDRESS FUNCTION - Opens modal
  const handleEditAddress = (address) => {
    setEditingAddressId(address.id);
    setIsEditing(true);
    setAddressInfo({
      name: address.newname || "",
      phone: address.phone || "",
      address: address.address || "",
      city: address.city || "",
      state: address.state || "",
      country: address.country || "",
      zip: address.zip_code || "",
    });
    setVerifiedPincode(address.zip_code);
    setPincodeValid(true);
    setShowEditModal(true);
  };

  // UPDATE ADDRESS FUNCTION
  const updateAddress = async () => {
    if (isUpdatingAddress.current) return;

    if (
      !addressInfo.name ||
      !addressInfo.phone ||
      !addressInfo.address ||
      !addressInfo.city ||
      !addressInfo.state ||
      !addressInfo.country ||
      !addressInfo.zip
    ) {
      return toast.error("Please fill all address fields");
    }

    isUpdatingAddress.current = true;

    try {
      const bodyData = {
        newname: addressInfo.name,
        phone: addressInfo.phone,
        address: addressInfo.address,
        city: addressInfo.city,
        state: addressInfo.state,
        country: addressInfo.country,
        zip_code: addressInfo.zip,
      };

      const response = await Api.put(
        `api/addresses/${editingAddressId}/`,
        bodyData
      );

      if (response?.status === 200) {
        await fetchCustomerAddresses();
        setShowEditModal(false);
        setIsEditing(false);
        setEditingAddressId(null);
        setAddressInfo({
          name: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          country: "",
          zip: "",
        });

        const updatedAddress = response.data;
        if (updatedAddress && updatedAddress.id) {
          await handleSelectAddress(updatedAddress);
        }

        toast.success("Address updated successfully");

        setPincodeCheck("");
        setPincodeValid(false);
        setPincodeChecked(false);
        setVerifiedPincode("");
        setPincodeMessage("");
      }
    } catch (error) {
      console.log("Update address error:", error);
      toast.error("Failed to update address");
    } finally {
      isUpdatingAddress.current = false;
    }
  };

  const handleProceedToAddress = () => {
    if (!pincodeValid) {
      toast.error("Please check pincode availability first");
      return;
    }

    if (!verifiedPincode) {
      toast.error("Please verify pincode first");
      return;
    }

    setShowAddressForm(true);
    setIsEditing(false);
    setEditingAddressId(null);
    setAddressInfo((prev) => ({ ...prev, zip: verifiedPincode }));
  };

  const saveNewAddress = async () => {
    if (isUpdatingAddress.current) return;

    if (
      !addressInfo.name ||
      !addressInfo.phone ||
      !addressInfo.address ||
      !addressInfo.city ||
      !addressInfo.state ||
      !addressInfo.country ||
      !addressInfo.zip
    ) {
      return toast.error("Please fill all address fields");
    }

    isUpdatingAddress.current = true;

    try {
      const bodyData = {
        newname: addressInfo.name,
        phone: addressInfo.phone,
        address: addressInfo.address,
        city: addressInfo.city,
        state: addressInfo.state,
        country: addressInfo.country,
        zip_code: addressInfo.zip,
        user_id: uid,
      };

      const response = await Api.post("api/addresses/", bodyData);

      if (response?.status === 201) {
        await fetchCustomerAddresses();
        setShowAddressForm(false);
        setIsEditing(false);
        setEditingAddressId(null);
        setAddressInfo({
          name: "",
          phone: "",
          address: "",
          city: "",
          state: "",
          country: "",
          zip: "",
        });

        const newAddress = response.data;
        if (newAddress && newAddress.id) {
          await handleSelectAddress(newAddress);
        }

        toast.success("Address added successfully");

        setPincodeCheck("");
        setPincodeValid(false);
        setPincodeChecked(false);
        setVerifiedPincode("");
        setPincodeMessage("");
      }
    } catch (error) {
      console.log("Save address error:", error);
      toast.error("Failed to add address");
    } finally {
      isUpdatingAddress.current = false;
    }
  };

  const formatDeliveryCharge = (charge) => {
    return charge === 0 ? "Free" : `₹${charge}`;
  };

  const handlePincodeChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      setPincodeCheck(value);
      if (value.length !== 6) {
        setPincodeValid(false);
        setPincodeChecked(false);
        setPincodeMessage("");
        setVerifiedPincode("");
      }
    }
  };

  const handleManualPincodeCheck = () => {
    if (pincodeCheck.length === 6) {
      checkPincode(pincodeCheck, false);
    } else {
      toast.error("Please enter a complete 6-digit pincode");
    }
  };

  const previousPriceRef = useRef(0);
const deliveryChargeRef = useRef(0);
const transactionChargeRef = useRef(0);
const discountRef = useRef(0);
const walletValueRef = useRef(0);

useEffect(() => {
  previousPriceRef.current = baseTotal;
}, [baseTotal]);

useEffect(() => {
  deliveryChargeRef.current = deliveryCharge;
}, [deliveryCharge]);

useEffect(() => {
  transactionChargeRef.current = transactionCharge;
}, [transactionCharge]);

useEffect(() => {
  discountRef.current = discount;
}, [discount]);

useEffect(() => {
  walletValueRef.current = walletValue;
}, [walletValue]);

const calculateFinalPrice = () => {
  let price = previousPriceRef.current;
  
  if (deliveryChargeRef.current >= 0) price += deliveryChargeRef.current;
  
  if (paymentMethod !== "cod" && transactionChargeRef.current >= 0) {
    price += transactionChargeRef.current;
  }
  
  if (couponApply || discountRef.current > 0) price -= discountRef.current;
  
  if (walletValueRef.current > 0) {
    if (price <= walletValueRef.current) {
      // Wallet covers full amount or more
      const remainingWallet = walletValueRef.current - price;
      setWalletValue(price); // Use exact amount from wallet
      price = 0;
    } else {
      price -= walletValueRef.current;
    }
  }
  
  if (price < 0) price = 0;
  
  setFinalPrice(price);
};

//   const calculateFinalPrice = () => {
//     console.log("previousPrice ::::::::: ",previousPrice)
//     let price = previousPrice;

//     if (deliveryCharge >= 0) price += deliveryCharge;

//     if (paymentMethod !== "cod" && transactionCharge >= 0) {
//       price += transactionCharge;
//       console.log(
//         "Adding transaction charge for online payment:",
//         transactionCharge
//       );
//     } else {
//       console.log("Skipping transaction charge for COD");
//     }

//     if (couponApply || discount > 0) price -= discount;

//     if (walletValue > 0) {
//       if (price - walletValue < 1) {
//         setWalletValue(price - 1);
//         price = 1;
//       } else {
//         price -= walletValue;
//       }
//     }

//     if (price < 0) price = 0;

//     console.log("Final price calculated:", {
//       previousPrice,
//       deliveryCharge,
//       transactionCharge: paymentMethod !== "cod" ? transactionCharge : 0,
//       discount,
//       walletValue,
//       finalPrice: price,
//       paymentMethod,
//     });
// console.log("price ::::::::::::::: ",price)
//     setFinalPrice(price);
//   };

  useEffect(() => {
    getProducts();
    getTotalPrice();
    fetchAvailableCoupons();
    fetchPurchaseBenefits();
    fetchPaymentOptions();
    fetchCustomerAddresses();
  }, [pickup]);

  useEffect(() => {
    calculateFinalPrice();
  }, [previousPrice, deliveryCharge, transactionCharge, discount, walletValue, paymentMethod]);

  useEffect(() => {
    setTimeout(() => {
      calculateFinalPrice();
    }, 500);
  }, []);

  const getProducts = async () => {
    try {
      const response = await Api.get(`api/get_cart/?user_id=${uid}`);
      setGetProduct(response.data);
    } catch (error) {
      console.error("Cart error:", error);
    }
  };

  const fetchAvailableCoupons = async () => {
    setLoadingCoupons(true);
    try {
      const response = await Api.get("api/get_all_coupon/");
      if (response.data.status === true) {
        setAvailableCoupons(response.data.coupons || []);
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
    } finally {
      setLoadingCoupons(false);
    }
  };

  const fetchPurchaseBenefits = async () => {
    setLoadingBenefits(true);
    try {
      const response = await Api.get("api/purchase-benefits/");
      if (response.data.status === true) {
        setPurchaseBenefits(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching purchase benefits:", error);
    } finally {
      setLoadingBenefits(false);
    }
  };

  const getTotalPrice = async (pickupVal = pickup) => {
    try {
      const response = await Api.get(
        `api/get_total_price/?user_id=${uid}&coupon_code=${couponApply ? couponCode : ""
        }&used_wallet=0&pick_up=${pickupVal}`
      );

      console.log("Total price response:", response.data);

      setBaseTotal(response.data.total_price);

      if (paymentMethod !== "cod") {
        const txCharge = response.data.transaction_fees || 0;
        setTransactionCharge(txCharge);
        console.log("Transaction charge set to:", txCharge);
      } else {
        setTransactionCharge(0);
        console.log("Transaction charge set to 0 for COD");
      }
console.log("response.data.previous_price ::::::::::::::::::::::: ",response.data.previous_price)
      setPreviousPrice(response.data.previous_price);

      if (!couponApply) {
        setDiscount(response.data.discounted_price);
      }

      if (!pincodeValid && !selectedAddressPincodeValid) {
        setDeliveryCharge(response.data.delivery_charge);
      }

      setGstPercentage(response.data.gst_rate || 0);
      setTotalGstAmount(response.data.total_gst || 0);
      setCgstAmount(response.data.cgst_amount || 0);
      setSgstAmount(response.data.sgst_amount || 0);
    } catch (error) {
      console.error("Price error:", error);
    }
  };

  const applyCoupon = async () => {
    try {
      if (!couponCode) return toast.error("Enter coupon code");

      const response = await Api.post("api/apply-coupon/", {
        coupon_code: couponCode,
        cart_value: baseTotal,
      });

      if (response.data.status === true) {
        setDiscount(response.data.discount);
        setCouponApply(true);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }

      calculateFinalPrice();
    } catch (error) {
      console.error("Coupon error:", error);
      toast.error("Invalid coupon");
    }
  };

  const removeCoupon = () => {
    setCouponApply(false);
    setCouponCode("");
    setDiscount(0);
    calculateFinalPrice();
    toast.info("Coupon removed");
  };

  const razorpayKeyId = "rzp_live_RYSfTyxfbAycrR";

  const handlePayment = async () => {
    if (deliveryOption === "delivery") {
      if (!selectedAddressId) {
        return alert("Please select a delivery address.");
      }

      const selectedAddress = addresses.find(
        (addr) => addr.id === selectedAddressId
      );

      if (!selectedAddress || !selectedAddress.zip_code) {
        return alert("Invalid address. Please check your delivery address.");
      }

      if (!selectedAddressPincodeValid) {
        const isValid = await checkPincode(selectedAddress.zip_code, true);
        if (!isValid) {
          toast.error("Delivery not available for this pincode");
          return;
        }
      }
    }

    const selectedAddress = addresses.find(
      (addr) => addr.id === selectedAddressId
    );
    const pick_up = deliveryOption === "delivery" ? 0 : 1;
    try {
      const bodyData = {
        user_id: uid,
        total_amount: finalPrice,
        newname: selectedAddress?.newname,
        address: selectedAddress?.address,
        city: selectedAddress?.city,
        state: selectedAddress?.state,
        country: selectedAddress?.country,
        zip_code: selectedAddress?.zip_code,
        phone: selectedAddress?.phone,
        delivery_time: selectedOption ? selectedOption : selectedPickup,
        coupon_code: couponCode,
        walet_value: walletValue,
        delivery_price: deliveryCharge,
        discounted_price: discount,
        previous_price: previousPrice,
        pick_up: pick_up,
        payment_method: paymentMethod,
        payment_option:
          paymentOptions.find((opt) => opt.code === paymentMethod)?.id || "",
      };

      const response = await Api.post("api/create_order/", bodyData);

      if (paymentMethod === "cod") {
        navigate("/orderdone");
        return;
      }

      const options = {
        currency: "INR",
        key: razorpayKeyId,
        amount: finalPrice * 100,
        name: "Frozenwala Cart",
        order_id: response.data.razorpay_order_id,
        handler: async function (res) {
          await Api.post("api/verify_payment/", {
            razorpay_payment_id: res.razorpay_payment_id,
            razorpay_order_id: res.razorpay_order_id,
            razorpay_signature: res.razorpay_signature,
          });
          navigate("/orderdone");
        },
      };

      new Razorpay(options).open();
    } catch (error) {
      console.error("Payment error:", error);
    }
  };
 
//   const handlePayment = async () => {
//   if (deliveryOption === "delivery") {
//     if (!selectedAddressId) {
//       return alert("Please select a delivery address.");
//     }

//     const selectedAddress = addresses.find(
//       (addr) => addr.id === selectedAddressId
//     );

//     if (!selectedAddress || !selectedAddress.zip_code) {
//       return alert("Invalid address. Please check your delivery address.");
//     }

//     if (!selectedAddressPincodeValid) {
//       const isValid = await checkPincode(selectedAddress.zip_code, true);
//       if (!isValid) {
//         toast.error("Delivery not available for this pincode");
//         return;
//       }
//     }
//   }

//   const selectedAddress = addresses.find(
//     (addr) => addr.id === selectedAddressId
//   );
//   const pick_up = deliveryOption === "delivery" ? 0 : 1;
  
//   try {
//     // Calculate if wallet covers full amount
//     const isFullyPaidByWallet = finalPrice === 0 && walletValue > 0;
    
//     const bodyData = {
//       user_id: uid,
//       total_amount: finalPrice,
//       newname: selectedAddress?.newname,
//       address: selectedAddress?.address,
//       city: selectedAddress?.city,
//       state: selectedAddress?.state,
//       country: selectedAddress?.country,
//       zip_code: selectedAddress?.zip_code,
//       phone: selectedAddress?.phone,
//       delivery_time: selectedOption ? selectedOption : selectedPickup,
//       coupon_code: couponCode,
//       walet_value: walletValue,
//       delivery_price: deliveryCharge,
//       discounted_price: discount,
//       previous_price: previousPrice,
//       pick_up: pick_up,
//       payment_method: isFullyPaidByWallet ? "wallet" : paymentMethod,
//       payment_option: isFullyPaidByWallet 
//         ? "wallet" 
//         : (paymentOptions.find((opt) => opt.code === paymentMethod)?.id || ""),
//     };

//     const response = await Api.post("api/create_order/", bodyData);

//     // If fully paid by wallet, just navigate to order done
//     if (isFullyPaidByWallet) {
//       toast.success("Order placed successfully using wallet balance!");
//       navigate("/orderdone");
//       return;
//     }
    
//     // If payment method is COD
//     if (paymentMethod === "cod") {
//       navigate("/orderdone");
//       return;
//     }

//     // Otherwise, open Razorpay for remaining amount
//     const options = {
//       currency: "INR",
//       key: razorpayKeyId,
//       amount: finalPrice * 100, // This will be the remaining amount after wallet
//       name: "Frozenwala Cart",
//       order_id: response.data.razorpay_order_id,
//       handler: async function (res) {
//         await Api.post("api/verify_payment/", {
//           razorpay_payment_id: res.razorpay_payment_id,
//           razorpay_order_id: res.razorpay_order_id,
//           razorpay_signature: res.razorpay_signature,
//         });
//         navigate("/orderdone");
//       },
//       prefill: {
//         name: selectedAddress?.newname || "",
//         email: localStorage.getItem("user_email") || "",
//         contact: selectedAddress?.phone || "",
//       },
//       theme: {
//         color: "#F37254",
//       },
//       modal: {
//         ondismiss: function() {
//           toast.info("Payment cancelled");
//         }
//       }
//     };

//     const razorpay = new Razorpay(options);
//     razorpay.open();
    
//     razorpay.on('payment.failed', function (response) {
//       toast.error("Payment failed: " + response.error.description);
//     });
    
//   } catch (error) {
//     console.error("Payment error:", error);
//     toast.error("Failed to process order. Please try again.");
//   }
// };
  
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setAddressInfo((prev) => ({ ...prev, [name]: value }));
  }, []);

  const isPayButtonEnabled = () => {
    if (deliveryOption === "delivery") {
      if (!selectedAddressId) return false;
      if (!selectedAddressPincodeValid) return false;
      return true;
    }
    return true;
  };

  const handleAddNewAddress = () => {
    setSelectedAddressId(null);
    setSelectedAddressPincodeValid(false);
    setShowAddressForm(true);
    setIsEditing(false);
    setEditingAddressId(null);
    setShowEditModal(false);
    setPincodeCheck("");
    setPincodeValid(false);
    setPincodeChecked(false);
    setVerifiedPincode("");
    setPincodeMessage("");
    setAddressInfo({
      name: "",
      phone: "",
      address: "",
      city: "",
      state: "",
      country: "",
      zip: "",
    });
  };

  const handleCheckAgain = () => {
    setPincodeValid(false);
    setPincodeChecked(false);
    setVerifiedPincode("");
    setPincodeMessage("");
    setPincodeCheck("");
  };

  useEffect(() => {
    setSelectedOption("Within 1hr");
    setSelectedPickup("Within 1hr");
  }, [deliveryOption]);

  return (
    <>
      <Navbar />

      <motion.div className="checkout-container">
        <div className="checkout-left">
          <div className="checkout-card">
            <h3>Customer Details</h3>

            <div className="option-buttons">
              <button
                className={`option-btn ${deliveryOption === "delivery" ? "active" : ""}`}
                onClick={() => {
                  setDeliveryOption("delivery");
                  setPickup(0);
                  getTotalPrice(0);
                }}
              >
                Delivery
              </button>

              <button
                className={`option-btn ${deliveryOption === "pickup" ? "active" : ""}`}
                onClick={() => {
                  setDeliveryOption("pickup");
                  setPickup(1);
                  getTotalPrice(1);
                }}
              >
                Pickup
              </button>
            </div>

            {deliveryOption === "delivery" && (
              <div className="address-form">
                <div className="pincode-check-section">
                  <h5>Check Delivery Availability</h5>
                  <div className="pincode-input-group">
                    <input
                      type="text"
                      placeholder="Enter 6-digit pincode"
                      value={pincodeCheck}
                      onChange={handlePincodeChange}
                      maxLength="6"
                      className="pincode-input"
                      disabled={pincodeValid && !showAddressForm}
                    />
                    <button
                      className="check-pincode-btn"
                      onClick={handleManualPincodeCheck}
                      disabled={
                        pincodeLoading || (pincodeValid && !showAddressForm)
                      }
                    >
                      {pincodeLoading ? "Checking..." : "Check"}
                    </button>
                  </div>

                  {pincodeChecked && pincodeCheck.length === 6 && (
                    <div
                      className={`pincode-message ${pincodeValid ? "valid" : "invalid"}`}
                    >
                      {pincodeLoading ? (
                        <span>Checking availability...</span>
                      ) : pincodeValid ? (
                        <span>
                          ✓ {pincodeMessage} - Delivery charge:{" "}
                          {formatDeliveryCharge(pincodeDeliveryCharge)}
                        </span>
                      ) : (
                        <span>✗ {pincodeMessage}</span>
                      )}
                    </div>
                  )}

                  {pincodeValid && !showAddressForm && (
                    <button
                      className="proceed-address-btn"
                      onClick={handleProceedToAddress}
                    >
                      Add New Address with this Pincode
                    </button>
                  )}
                </div>

                {/* EXISTING ADDRESSES WITH EDIT BUTTON */}
                {addresses && addresses.length > 0 && (
                  <div className="existing-addresses-section">
                    <h5>Select Existing Address</h5>
                    <div className="addresses-list">
                      {addresses.map((address) => (
                        <div
                          key={address.id}
                          className={`address-card ${selectedAddressId === address.id ? "selected" : ""
                            } ${selectedAddressId === address.id &&
                              !selectedAddressPincodeValid
                              ? "invalid-pincode"
                              : ""
                            }`}
                        >
                          <div className="address-radio">
                            <input
                              type="radio"
                              name="address-selection"
                              checked={selectedAddressId === address.id}
                              onChange={() => handleSelectAddress(address)}
                              disabled={checkingSelectedAddress}
                            />
                          </div>
                          <div className="address-details">
                            <p className="address-name">
                              <strong>{address.newname}</strong>
                            </p>
                            <p className="address-phone">{address.phone}</p>
                            <p className="address-text">
                              {address.address}, {address.city}, {address.state}{" "}
                              {address.zip_code}, {address.country}
                            </p>
                            {selectedAddressId === address.id &&
                              checkingSelectedAddress && (
                                <p className="pincode-checking">
                                  Checking pincode availability...
                                </p>
                              )}
                            {selectedAddressId === address.id &&
                              selectedAddressPincodeValid && (
                                <p className="pincode-valid-msg">
                                  ✓ Delivery available for this pincode
                                </p>
                              )}
                            {selectedAddressId === address.id &&
                              !selectedAddressPincodeValid &&
                              !checkingSelectedAddress && (
                                <p className="pincode-invalid-msg">
                                  ✗ Delivery not available for pincode{" "}
                                  {address.zip_code}
                                </p>
                              )}
                          </div>
                          <div className="address-actions">
                            <button
                              className="edit-address-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditAddress(address);
                              }}
                              title="Edit Address"
                            >
                              ✏️ Edit
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* ALWAYS SHOW ADD NEW ADDRESS BUTTON */}
                <button
                  className="add-new-address-btn"
                  onClick={handleAddNewAddress}
                >
                  + Add New Address
                </button>

                {/* ADDRESS FORM (ADD ONLY - EDIT USES MODAL) */}
                {showAddressForm && !isEditing && (
                  <div className="new-address-form">
                    <h5>
                      Add Delivery Address
                      {verifiedPincode ? ` for Pincode: ${verifiedPincode}` : ""}
                    </h5>
                    <div className="address-fields">
                      <input
                        type="text"
                        name="name"
                        placeholder="Full Name"
                        value={addressInfo.name}
                        onChange={handleChange}
                      />
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Phone Number"
                        value={addressInfo.phone}
                        onChange={handleChange}
                      />
                      <textarea
                        name="address"
                        placeholder="Address"
                        value={addressInfo.address}
                        onChange={handleChange}
                        rows="2"
                      />
                      <input
                        type="text"
                        name="city"
                        placeholder="City"
                        value={addressInfo.city}
                        onChange={handleChange}
                      />
                      <input
                        type="text"
                        name="state"
                        placeholder="State"
                        value={addressInfo.state}
                        onChange={handleChange}
                      />
                      <input
                        type="text"
                        name="country"
                        placeholder="Country"
                        value={addressInfo.country}
                        onChange={handleChange}
                      />
                      <input
                        type="text"
                        name="zip"
                        placeholder="Pincode"
                        value={addressInfo.zip}
                        onChange={handleChange}
                        disabled={!!verifiedPincode && !isEditing}
                        className={
                          verifiedPincode && !isEditing ? "disabled-input" : ""
                        }
                      />
                    </div>

                    <div className="address-form-buttons">
                      <button
                        className="save-address-btn"
                        onClick={saveNewAddress}
                      >
                        Save Address
                      </button>
                      <button
                        className="cancel-address-btn"
                        onClick={() => {
                          setShowAddressForm(false);
                          setIsEditing(false);
                          setEditingAddressId(null);
                          setAddressInfo({
                            name: "",
                            phone: "",
                            address: "",
                            city: "",
                            state: "",
                            country: "",
                            zip: "",
                          });
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}

                {selectedAddressId && selectedAddressPincodeValid && (
                  <>
                    <div className="delivery-timing">
                      <h5>Select Delivery Timing:</h5>
                      <div className="timing-options">
                        {["Within 1hr", "1-3 hrs"].map((time) => (
                          <label key={time}>
                            <input
                              type="radio"
                              checked={selectedOption === time}
                              onChange={() => setSelectedOption(time)}
                            />
                            {time}
                          </label>
                        ))}
                      </div>
                    </div>

                    {paymentOptions && paymentOptions?.length > 0 && (
                      <div className="payment-method">
                        <h5>Select Payment Method:</h5>
                        <div className="payment-options">
                          {paymentOptions.map((option) => (
                            <label key={option.value}>
                              <input
                                type="radio"
                                value={option.code}
                                checked={paymentMethod === option.code}
                                onChange={(e) => {
                                  setPaymentMethod(e.target.value);
                                  setTimeout(() => {
                                    calculateFinalPrice();
                                  }, 50);
                                }}
                              />
                              {option.display_name}
                            </label>
                          ))}
                        </div>
                      </div>
                    )}
                    {paymentOptions && paymentOptions?.length > 0 && (
                      <button
                        className="pay-btn"
                        onClick={handlePayment}
                        disabled={!isPayButtonEnabled()}
                      >
                        {paymentMethod === "cod"
                          ? "Place Order (COD)"
                          : "Proceed to Pay"}
                      </button>
                    )}
                  </>
                )}
              </div>
            )}

            {deliveryOption === "pickup" && (
              <div className="pickup-form">
                <h5>Select Pickup Timing</h5>
                <div className="pickup-timing">
                  {["Within 1hr", "1hr–3hrs"].map((time) => (
                    <label key={time}>
                      <input
                        type="radio"
                        checked={selectedPickup === time}
                        onChange={() => setSelectedPickup(time)}
                      />
                      {time}
                    </label>
                  ))}
                </div>
                {paymentOptions && paymentOptions?.length > 0 && (
                  <div className="payment-method">
                    <h5>Select Payment Method:</h5>
                    <div className="payment-options">
                      {paymentOptions.map((option) => (
                        <label key={option.value}>
                          <input
                            type="radio"
                            value={option.code}
                            checked={paymentMethod === option.code}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                          />
                          {option.display_name}
                        </label>
                      ))}
                    </div>
                  </div>
                )}

                {paymentOptions && paymentOptions?.length > 0 && (
                  <button className="pay-btn" onClick={handlePayment}>
                    {paymentMethod === "cod"
                      ? "Place Order (COD)"
                      : "Proceed to Pay"}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="checkout-right">
          <h3>Items</h3>

          {getProduct?.map((item) => (
            <div className="item-card" key={item.id}>
              <div className="item-info">
                <img src={item.product_image || logo} alt={item.product_name} />
                <div>
                  <span className="item-name">{item.product_name}</span>
                  <p>₹{item.price}</p>
                </div>
              </div>
              <span>Qty {item.quantity}</span>
            </div>
          ))}

          <div className="price-summary">
            <div className="available-coupons-section">
              <h4>Available Coupon Offers</h4>
              {loadingCoupons ? (
                <div className="coupon-loading">Loading offers...</div>
              ) : availableCoupons.length > 0 ? (
                <div className="coupon-cards-container">
                  {availableCoupons.map((coupon, index) => (
                    <div
                      className="coupon-card"
                      key={index}
                      onClick={() => {
                        setCouponCode(coupon.coupon);
                        toast.info(
                          `Coupon ${coupon.coupon} copied! Click Apply to use.`
                        );
                      }}
                    >
                      <div className="coupon-header">
                        <span className="coupon-code">{coupon.coupon}</span>
                        <span className="coupon-badge">
                          {coupon.coupon_type === "Flat" ? "₹" : "%"}
                        </span>
                      </div>
                      <div className="coupon-body">
                        <p className="coupon-value">
                          {coupon.coupon_type === "Flat"
                            ? `₹${coupon.coupon_value} OFF`
                            : `${coupon.coupon_value}% OFF`}
                        </p>
                        <p className="coupon-minimum">
                          Min. purchase: ₹{coupon.minimum_purchase}
                        </p>
                      </div>
                      <div className="coupon-footer">
                        <p className="coupon-description">
                          {coupon.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-coupons">
                  No offers available at the moment
                </div>
              )}

              <p className="coupon-hint">
                👆 Click on any coupon to copy, then click Apply
              </p>
            </div>

            <div className="purchase-benefits-section">
              <h4>Purchase Benefits</h4>
              {loadingBenefits ? (
                <div className="benefit-loading">Loading benefits...</div>
              ) : purchaseBenefits.length > 0 ? (
                <div className="benefit-cards-container">
                  {purchaseBenefits.map((benefit, index) => (
                    <div className="benefit-card" key={benefit.id}>
                      <div className="benefit-header">
                        <span className="benefit-title">
                          Spend ₹{benefit.price}
                        </span>
                        <span className="benefit-badge">
                          {benefit.benefit_percentage}%
                        </span>
                      </div>
                      <div className="benefit-body">
                        <p className="benefit-description">
                          Get {benefit.benefit_percentage}% benefit on your
                          purchase
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-benefits">
                  No purchase benefits available at the moment
                </div>
              )}
            </div>

            <div className="coupon-input-section">
              <input
                type="text"
                placeholder="Enter Coupon Code"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                className="coupon-input"
              />
              {couponApply ? (
                <button onClick={removeCoupon} className="apply-btn remove-btn">
                  Remove
                </button>
              ) : (
                <button onClick={applyCoupon} className="apply-btn">
                  Apply Coupon
                </button>
              )}
            </div>

            {/* <div className="summary-row">
              <p>Wallet Balance: ₹{walletBalance.toFixed(2)}</p>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={walletValue > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setWalletValue(walletBalance);
                    } else {
                      setWalletValue(0);
                    }
                  }}
                />
                <span className="slider"></span>
              </label>
            </div> */}
                   {/*    <div className="summary-row">
            <p>Wallet Balance: ₹{walletBalance.toFixed(2)}</p>
            <label className="switch">
              <input
                type="checkbox"
                checked={walletValue > 0}
                onChange={(e) => {
                  if (e.target.checked) {
                    // Calculate how much wallet to use
                    const totalBeforeWallet = previousPrice + deliveryCharge + (paymentMethod !== "cod" ? transactionCharge : 0) - discount;
                    if (totalBeforeWallet <= walletBalance) {
                      // Use only what's needed
                      setWalletValue(totalBeforeWallet);
                    } else {
                      setWalletValue(walletBalance);
                    }
                  } else {
                    setWalletValue(0);
                  }
                }}
              />
              <span className="slider"></span>
            </label>
          </div>*/}

          <div className="summary-row">
  <p>Wallet Balance: ₹{walletBalance.toFixed(2)}</p>
  <label className="switch">
    <input
      type="checkbox"
      checked={walletValue > 0}
      onChange={(e) => {
        if (e.target.checked) {
          // Calculate total amount before wallet
          let totalAmount = previousPrice + deliveryCharge;
          
          if (paymentMethod !== "cod" && transactionCharge >= 0) {
            totalAmount += transactionCharge;
          }
          
          if (couponApply && discount > 0) {
            totalAmount -= discount;
          }
          
          // Use wallet up to the total amount
          if (totalAmount <= walletBalance) {
            setWalletValue(totalAmount);
          } else {
            setWalletValue(walletBalance);
          }
        } else {
          setWalletValue(0);
        }
      }}
    />
    <span className="slider"></span>
  </label>
</div>

            <div className="summary-card">
              <h4 className="summary-title">Price Summary</h4>

              <div className="summary-row">
                <span>Total Items Price</span>
                <span>₹{baseTotal}</span>
              </div>

              {gstPercentage > 0 && (
                <>
                  <div className="summary-row">
                    <span>CGST</span>
                    <span>₹{cgstAmount}</span>
                  </div>

                  <div className="summary-row">
                    <span>SGST</span>
                    <span>₹{sgstAmount}</span>
                  </div>

                  <div className="summary-row">
                    <span>Total GST</span>
                    <span>₹{totalGstAmount}</span>
                  </div>

                  <div className="summary-divider" />
                </>
              )}

              <div className="summary-row">
                <span>Delivery</span>
                <span>₹{deliveryCharge}</span>
              </div>

              {paymentMethod !== "cod" && (
                <div className="summary-row">
                  <span>Transaction</span>
                  <span>₹{transactionCharge}</span>
                </div>
              )}

              <div className="summary-row discount">
                <span>Discount</span>
                <span>- ₹{discount}</span>
              </div>

              <div className="summary-row wallet">
                <span>Wallet Used</span>
                <span>- ₹{walletValue}</span>
              </div>

              <div className="summary-divider" />

              <div className="summary-total">
                <span>Grand Total</span>
                <span>₹{finalPrice.toFixed(2)}</span>
              </div>

              {paymentMethod === "cod" ? (
                <p className="summary-note" style={{ color: "#4CAF50" }}>
                  ✓ No transaction fee applied for Cash on Delivery
                </p>
              ) : (
                <p className="summary-note">
                  * Transaction fee includes payment gateway charges
                </p>
              )}

              <p className="summary-note">
                All prices are inclusive of applicable taxes.
              </p>
            </div>
          </div>
        </div>
      </motion.div>

      {/* =====================================================
          EDIT ADDRESS MODAL — Inlined to prevent focus loss.
          DO NOT convert this back into a sub-component or
          useCallback component; doing so causes React to
          unmount/remount the inputs on every keystroke.
         ===================================================== */}
      {showEditModal && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3>Edit Delivery Address</h3>
              <button
                className="modal-close"
                onClick={() => setShowEditModal(false)}
              >
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="address-fields">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={addressInfo.name}
                  onChange={handleChange}
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={addressInfo.phone}
                  onChange={handleChange}
                />
                <textarea
                  name="address"
                  placeholder="Address"
                  value={addressInfo.address}
                  onChange={handleChange}
                  rows="2"
                />
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={addressInfo.city}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="state"
                  placeholder="State"
                  value={addressInfo.state}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="country"
                  placeholder="Country"
                  value={addressInfo.country}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  name="zip"
                  placeholder="Pincode"
                  value={addressInfo.zip}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="cancel-address-btn"
                onClick={() => setShowEditModal(false)}
              >
                Cancel
              </button>
              <button className="save-address-btn" onClick={updateAddress}>
                Update Address
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default CheckoutPage;

// import React, { useEffect, useState, useCallback, useRef } from "react";
// import Api from "../Utills/Api.js";
// import Footer from "../Home/Footer";
// import Navbar from "../Home/Navbar";
// import { useNavigate } from "react-router-dom";
// import useRazorpay from "react-razorpay";
// import logo from "../../Frozenwala.png";
// import { motion } from "framer-motion";
// import "./Checkout.css";
// import { toast } from "react-toastify";

// const CheckoutPage = () => {
//   const navigate = useNavigate();
//   const [Razorpay] = useRazorpay();

//   // Scroll to top when component mounts
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // STATES
//   const [deliveryOption, setDeliveryOption] = useState("delivery");
//   const [selectedPickup, setSelectedPickup] = useState("Within 1hr");
//   const [selectedOption, setSelectedOption] = useState("Within 1hr");
//   const [getProduct, setGetProduct] = useState([]);
//   const [paymentMethod, setPaymentMethod] = useState("online");
//   const [paymentOptions, setPaymentOptions] = useState([]);
//   const [addresses, setAddresses] = useState([]);
//   const [transactionCharge, setTransactionCharge] = useState(0);

//   // PINCODE VALIDATION STATES
//   const [pincodeCheck, setPincodeCheck] = useState("");
//   const [pincodeValid, setPincodeValid] = useState(false);
//   const [pincodeLoading, setPincodeLoading] = useState(false);
//   const [pincodeChecked, setPincodeChecked] = useState(false);
//   const [selectedAddressPincodeValid, setSelectedAddressPincodeValid] = useState(false);
//   const [checkingSelectedAddress, setCheckingSelectedAddress] = useState(false);
//   const [showAddressForm, setShowAddressForm] = useState(false);
//   const [pincodeDeliveryCharge, setPincodeDeliveryCharge] = useState(0);
//   const [pincodeMessage, setPincodeMessage] = useState("");
//   const [verifiedPincode, setVerifiedPincode] = useState("");

//   // EDIT ADDRESS STATES
//   const [editingAddressId, setEditingAddressId] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);

//   // Recalculate when payment method changes
//   // useEffect(() => {
//   //   if (paymentMethod === "cod") {
//   //     setTransactionCharge(0);
//   //   } else {
//   //     getTotalPrice();
//   //   }
//   //   setTimeout(() => {
//   //     calculateFinalPrice();
//   //   }, 100);
//   // }, [paymentMethod]);

// useEffect(() => {
//   if (paymentMethod === "cod") {
//     setTransactionCharge(0);
//     calculateFinalPrice("cod"); // ← pass explicitly, don't rely on stale closure
//   } else {
//     getTotalPrice().then(() => {
//       calculateFinalPrice("online");
//     });
//   }
// }, [paymentMethod]);

//   const fetchCustomerAddresses = async () => {
//     try {
//       const response = await Api.get(`api/addresses/?user_id=${uid}`);
//       if (response?.data && response?.data?.length > 0) {
//         setAddresses(response?.data);
//       } else {
//         setAddresses([]);
//       }
//     } catch (error) {
//       console.log("Address fetch error:", error);
//       setAddresses([]);
//     }
//   };

//   const fetchPaymentOptions = async () => {
//     try {
//       const response = await Api.get("api/payment-options/");
//       if (response?.data && response?.data?.length > 0) {
//         setPaymentOptions(response?.data);
//       }
//     } catch (error) {
//       console.log("Payment options error:", error);
//     }
//   };

//   // COUPONS
//   const [availableCoupons, setAvailableCoupons] = useState([]);
//   const [loadingCoupons, setLoadingCoupons] = useState(false);

//   // PURCHASE BENEFITS
//   const [purchaseBenefits, setPurchaseBenefits] = useState([]);
//   const [loadingBenefits, setLoadingBenefits] = useState(false);

//   // PRICE STATES
//   const [baseTotal, setBaseTotal] = useState(0);
//   const [previousPrice, setPreviousPrice] = useState(0);
//   const [deliveryCharge, setDeliveryCharge] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [finalPrice, setFinalPrice] = useState(0);

//   // GST STATES
//   const [totalGstAmount, setTotalGstAmount] = useState(0);
//   const [gstPercentage, setGstPercentage] = useState(0);
//   const [cgstAmount, setCgstAmount] = useState(0);
//   const [sgstAmount, setSgstAmount] = useState(0);

//   // WALLET
//   const wallet = Number(localStorage.getItem("wallet") || 0);
//   const [walletValue, setWalletValue] = useState(0);
//   const [walletBalance, setWalletBalance] = useState(wallet);

//   // COUPON INPUT
//   const [couponCode, setCouponCode] = useState("");
//   const [couponApply, setCouponApply] = useState(false);
//   const [pickup, setPickup] = useState(0);

//   const uid = localStorage.getItem("user_id");

//   const [addressInfo, setAddressInfo] = useState({
//     name: "",
//     phone: "",
//     address: "",
//     city: "",
//     state: "",
//     country: "",
//     zip: "",
//   });

//   const [selectedAddressId, setSelectedAddressId] = useState(null);

//   // Refs to prevent unnecessary re-renders
//   const isUpdatingAddress = useRef(false);

//   const checkPincode = async (pincodeToCheck, isForSelectedAddress = false) => {
//     if (!pincodeToCheck || pincodeToCheck.length !== 6) {
//       if (!isForSelectedAddress) {
//         toast.error("Please enter a valid 6-digit pincode");
//       }
//       return false;
//     }

//     if (isForSelectedAddress) {
//       setCheckingSelectedAddress(true);
//     } else {
//       setPincodeLoading(true);
//     }

//     try {
//       const response = await Api.post("api/check_pincode/", {
//         pincode: pincodeToCheck,
//       });

//       console.log("Pincode response:", response.data);

//       if (
//         response.data &&
//         response.data.success === true &&
//         response.data.available === true
//       ) {
//         const deliveryChargeAmount = response.data.delivery_charge || 0;
//         const message = response.data.message || "Delivery available";

//         if (!isForSelectedAddress) {
//           setPincodeValid(true);
//           setPincodeDeliveryCharge(deliveryChargeAmount);
//           setPincodeMessage(message);
//           setVerifiedPincode(pincodeToCheck);
//           setPincodeChecked(true);
//           setDeliveryCharge(deliveryChargeAmount);
//           toast.success(message);
//         } else {
//           setSelectedAddressPincodeValid(true);
//           setDeliveryCharge(deliveryChargeAmount);
//           toast.success("Delivery available for this address!");
//         }
//         return true;
//       } else {
//         const errorMessage =
//           response.data?.message || "Delivery not available for this pincode";

//         if (!isForSelectedAddress) {
//           setPincodeValid(false);
//           setPincodeDeliveryCharge(0);
//           setPincodeMessage(errorMessage);
//           setVerifiedPincode("");
//           setPincodeChecked(true);
//           if (!selectedAddressPincodeValid) {
//             setDeliveryCharge(0);
//           }
//           toast.error(errorMessage);
//         } else {
//           setSelectedAddressPincodeValid(false);
//           setDeliveryCharge(0);
//           toast.error(errorMessage);
//         }
//         return false;
//       }
//     } catch (error) {
//       console.error("Pincode check error:", error);

//       let errorMessage = "Failed to verify pincode. Please try again.";

//       if (error.response && error.response.data) {
//         errorMessage = error.response.data.message || errorMessage;

//         if (!isForSelectedAddress) {
//           setPincodeValid(false);
//           setPincodeDeliveryCharge(0);
//           setPincodeMessage(errorMessage);
//           setVerifiedPincode("");
//           setPincodeChecked(true);
//           if (!selectedAddressPincodeValid) {
//             setDeliveryCharge(0);
//           }
//         } else {
//           setSelectedAddressPincodeValid(false);
//           setDeliveryCharge(0);
//         }
//       } else {
//         if (!isForSelectedAddress) {
//           setPincodeValid(false);
//           setPincodeDeliveryCharge(0);
//           setPincodeMessage(errorMessage);
//           setVerifiedPincode("");
//           setPincodeChecked(true);
//           if (!selectedAddressPincodeValid) {
//             setDeliveryCharge(0);
//           }
//         } else {
//           setSelectedAddressPincodeValid(false);
//           setDeliveryCharge(0);
//         }
//       }

//       toast.error(errorMessage);
//       return false;
//     } finally {
//       if (isForSelectedAddress) {
//         setCheckingSelectedAddress(false);
//       } else {
//         setPincodeLoading(false);
//       }
//     }
//   };

//   const handleSelectAddress = async (address) => {
//     if (!address.zip_code || address.zip_code.length !== 6) {
//       toast.error("Invalid pincode in selected address");
//       setSelectedAddressId(null);
//       setSelectedAddressPincodeValid(false);
//       setDeliveryCharge(0);
//       return;
//     }

//     setSelectedAddressId(address.id);
//     setShowAddressForm(false);
//     setIsEditing(false);
//     setEditingAddressId(null);
//     setShowEditModal(false);

//     setSelectedAddressPincodeValid(false);

//     const isValid = await checkPincode(address.zip_code, true);

//     if (!isValid) {
//       setSelectedAddressId(null);
//       setDeliveryCharge(0);
//     }
//   };

//   // EDIT ADDRESS FUNCTION - Opens modal
//   const handleEditAddress = (address) => {
//     setEditingAddressId(address.id);
//     setIsEditing(true);
//     setAddressInfo({
//       name: address.newname || "",
//       phone: address.phone || "",
//       address: address.address || "",
//       city: address.city || "",
//       state: address.state || "",
//       country: address.country || "",
//       zip: address.zip_code || "",
//     });
//     setVerifiedPincode(address.zip_code);
//     setPincodeValid(true);
//     setShowEditModal(true);
//   };

//   // UPDATE ADDRESS FUNCTION
//   const updateAddress = async () => {
//     if (isUpdatingAddress.current) return;

//     if (
//       !addressInfo.name ||
//       !addressInfo.phone ||
//       !addressInfo.address ||
//       !addressInfo.city ||
//       !addressInfo.state ||
//       !addressInfo.country ||
//       !addressInfo.zip
//     ) {
//       return toast.error("Please fill all address fields");
//     }

//     isUpdatingAddress.current = true;

//     try {
//       const bodyData = {
//         newname: addressInfo.name,
//         phone: addressInfo.phone,
//         address: addressInfo.address,
//         city: addressInfo.city,
//         state: addressInfo.state,
//         country: addressInfo.country,
//         zip_code: addressInfo.zip,
//       };

//       const response = await Api.put(
//         `api/addresses/${editingAddressId}/`,
//         bodyData
//       );

//       if (response?.status === 200) {
//         await fetchCustomerAddresses();
//         setShowEditModal(false);
//         setIsEditing(false);
//         setEditingAddressId(null);
//         setAddressInfo({
//           name: "",
//           phone: "",
//           address: "",
//           city: "",
//           state: "",
//           country: "",
//           zip: "",
//         });

//         const updatedAddress = response.data;
//         if (updatedAddress && updatedAddress.id) {
//           await handleSelectAddress(updatedAddress);
//         }

//         toast.success("Address updated successfully");

//         setPincodeCheck("");
//         setPincodeValid(false);
//         setPincodeChecked(false);
//         setVerifiedPincode("");
//         setPincodeMessage("");
//       }
//     } catch (error) {
//       console.log("Update address error:", error);
//       toast.error("Failed to update address");
//     } finally {
//       isUpdatingAddress.current = false;
//     }
//   };

//   const handleProceedToAddress = () => {
//     if (!pincodeValid) {
//       toast.error("Please check pincode availability first");
//       return;
//     }

//     if (!verifiedPincode) {
//       toast.error("Please verify pincode first");
//       return;
//     }

//     setShowAddressForm(true);
//     setIsEditing(false);
//     setEditingAddressId(null);
//     setAddressInfo((prev) => ({ ...prev, zip: verifiedPincode }));
//   };

//   const saveNewAddress = async () => {
//     if (isUpdatingAddress.current) return;

//     if (
//       !addressInfo.name ||
//       !addressInfo.phone ||
//       !addressInfo.address ||
//       !addressInfo.city ||
//       !addressInfo.state ||
//       !addressInfo.country ||
//       !addressInfo.zip
//     ) {
//       return toast.error("Please fill all address fields");
//     }

//     isUpdatingAddress.current = true;

//     try {
//       const bodyData = {
//         newname: addressInfo.name,
//         phone: addressInfo.phone,
//         address: addressInfo.address,
//         city: addressInfo.city,
//         state: addressInfo.state,
//         country: addressInfo.country,
//         zip_code: addressInfo.zip,
//         user_id: uid,
//       };

//       const response = await Api.post("api/addresses/", bodyData);

//       if (response?.status === 201) {
//         await fetchCustomerAddresses();
//         setShowAddressForm(false);
//         setIsEditing(false);
//         setEditingAddressId(null);
//         setAddressInfo({
//           name: "",
//           phone: "",
//           address: "",
//           city: "",
//           state: "",
//           country: "",
//           zip: "",
//         });

//         const newAddress = response.data;
//         if (newAddress && newAddress.id) {
//           await handleSelectAddress(newAddress);
//         }

//         toast.success("Address added successfully");

//         setPincodeCheck("");
//         setPincodeValid(false);
//         setPincodeChecked(false);
//         setVerifiedPincode("");
//         setPincodeMessage("");
//       }
//     } catch (error) {
//       console.log("Save address error:", error);
//       toast.error("Failed to add address");
//     } finally {
//       isUpdatingAddress.current = false;
//     }
//   };

//   const formatDeliveryCharge = (charge) => {
//     return charge === 0 ? "Free" : `₹${charge}`;
//   };

//   const handlePincodeChange = (e) => {
//     const value = e.target.value;
//     if (/^\d*$/.test(value) && value.length <= 6) {
//       setPincodeCheck(value);
//       if (value.length !== 6) {
//         setPincodeValid(false);
//         setPincodeChecked(false);
//         setPincodeMessage("");
//         setVerifiedPincode("");
//       }
//     }
//   };

//   const handleManualPincodeCheck = () => {
//     if (pincodeCheck.length === 6) {
//       checkPincode(pincodeCheck, false);
//     } else {
//       toast.error("Please enter a complete 6-digit pincode");
//     }
//   };

//   // const calculateFinalPrice = () => {
//   //   let price = previousPrice;

//   //   if (deliveryCharge >= 0) price += deliveryCharge;

//   //   if (paymentMethod !== "cod" && transactionCharge >= 0) {
//   //     price += transactionCharge;
//   //     console.log(
//   //       "Adding transaction charge for online payment:",
//   //       transactionCharge
//   //     );
//   //   } else {
//   //     console.log("Skipping transaction charge for COD");
//   //   }

//   //   if (couponApply || discount > 0) price -= discount;

//   //   if (walletValue > 0) {
//   //     if (price - walletValue < 1) {
//   //       setWalletValue(price - 1);
//   //       price = 1;
//   //     } else {
//   //       price -= walletValue;
//   //     }
//   //   }

//   //   if (price < 0) price = 0;

//   //   console.log("Final price calculated:", {
//   //     previousPrice,
//   //     deliveryCharge,
//   //     transactionCharge: paymentMethod !== "cod" ? transactionCharge : 0,
//   //     discount,
//   //     walletValue,
//   //     finalPrice: price,
//   //     paymentMethod,
//   //   });
//   //   console.log("price : ",price)

//   //   setFinalPrice(price);
//   // };
// // Add this computed value just before your return statement (or inside the JSX block)
// const effectiveWalletUsed = (() => {
//   if (walletValue <= 0) return 0;
//   let priceBeforeWallet = previousPrice + deliveryCharge
//     + (paymentMethod !== "cod" ? transactionCharge : 0)
//     - discount;
//   if (priceBeforeWallet < 0) priceBeforeWallet = 0;

//   if (paymentMethod === "cod") {
//     return Math.min(walletValue, priceBeforeWallet); // ← caps at ₹73, not ₹776
//   } else {
//     const maxUsable = priceBeforeWallet - 1;
//     return maxUsable > 0 ? Math.min(walletValue, maxUsable) : 0;
//   }
// })();
// const calculateFinalPrice = (currentPaymentMethod = paymentMethod) => {
//   let price = previousPrice;

//   if (deliveryCharge >= 0) price += deliveryCharge;

//   // Use the passed-in method, not the stale closure value
//   if (currentPaymentMethod !== "cod" && transactionCharge >= 0) {
//     price += transactionCharge;
//   }

//   if (couponApply || discount > 0) price -= discount;

//   if (walletValue > 0) {
//     if (currentPaymentMethod === "cod") {
//       const effectiveWallet = Math.min(walletValue, price);
//       price -= effectiveWallet;
//     } else {
//       if (price - walletValue < 1) {
//         price = 1;
//       } else {
//         price -= walletValue;
//       }
//     }
//   }

//   if (price < 0) price = 0;
//   setFinalPrice(price);
// };

//   useEffect(() => {
//     getProducts();
//     getTotalPrice();
//     fetchAvailableCoupons();
//     fetchPurchaseBenefits();
//     fetchPaymentOptions();
//     fetchCustomerAddresses();
//   }, [pickup]);

//   useEffect(() => {
//     calculateFinalPrice();
//   }, [previousPrice, deliveryCharge, transactionCharge, discount, walletValue, paymentMethod]);

//   // useEffect(() => {
//   //   setTimeout(() => {
//   //     calculateFinalPrice();
//   //   }, 500);
//   // }, []);

//   const getProducts = async () => {
//     try {
//       const response = await Api.get(`api/get_cart/?user_id=${uid}`);
//       setGetProduct(response.data);
//     } catch (error) {
//       console.error("Cart error:", error);
//     }
//   };

//   const fetchAvailableCoupons = async () => {
//     setLoadingCoupons(true);
//     try {
//       const response = await Api.get("api/get_all_coupon/");
//       if (response.data.status === true) {
//         setAvailableCoupons(response.data.coupons || []);
//       }
//     } catch (error) {
//       console.error("Error fetching coupons:", error);
//     } finally {
//       setLoadingCoupons(false);
//     }
//   };

//   const fetchPurchaseBenefits = async () => {
//     setLoadingBenefits(true);
//     try {
//       const response = await Api.get("api/purchase-benefits/");
//       if (response.data.status === true) {
//         setPurchaseBenefits(response.data.data || []);
//       }
//     } catch (error) {
//       console.error("Error fetching purchase benefits:", error);
//     } finally {
//       setLoadingBenefits(false);
//     }
//   };

//   // const getTotalPrice = async (pickupVal = pickup) => {
//   //   try {
//   //     const response = await Api.get(
//   //       `api/get_total_price/?user_id=${uid}&coupon_code=${couponApply ? couponCode : ""
//   //       }&used_wallet=0&pick_up=${pickupVal}`
//   //     );

//   //     console.log("Total price response:", response.data);

//   //     setBaseTotal(response.data.total_price);

//   //     if (paymentMethod !== "cod") {
//   //       const txCharge = response.data.transaction_fees || 0;
//   //       setTransactionCharge(txCharge);
//   //       console.log("Transaction charge set to:", txCharge);
//   //     } else {
//   //       setTransactionCharge(0);
//   //       console.log("Transaction charge set to 0 for COD");
//   //     }

//   //     setPreviousPrice(response.data.previous_price);

//   //     if (!couponApply) {
//   //       setDiscount(response.data.discounted_price);
//   //     }

//   //     if (!pincodeValid && !selectedAddressPincodeValid) {
//   //       setDeliveryCharge(response.data.delivery_charge);
//   //     }

//   //     setGstPercentage(response.data.gst_rate || 0);
//   //     setTotalGstAmount(response.data.total_gst || 0);
//   //     setCgstAmount(response.data.cgst_amount || 0);
//   //     setSgstAmount(response.data.sgst_amount || 0);
//   //   } catch (error) {
//   //     console.error("Price error:", error);
//   //   }
//   // };

//   const getTotalPrice = async (pickupVal = pickup) => {
//   try {
//     const response = await Api.get(
//       `api/get_total_price/?user_id=${uid}&coupon_code=${couponApply ? couponCode : ""
//       }&used_wallet=0&pick_up=${pickupVal}`
//     );

//     console.log("Total price response:", response.data);

//     setBaseTotal(response.data.total_price);
    
//     // Only set transaction charge if payment method is not COD
//     if (paymentMethod !== "cod") {
//       const txCharge = response.data.transaction_fees || 0;
//       setTransactionCharge(txCharge);
//       console.log("Transaction charge set to:", txCharge);
//     } else {
//       setTransactionCharge(0);
//       console.log("Transaction charge set to 0 for COD");
//     }

//     // ALWAYS set previous price from API response, don't conditionally skip
//     setPreviousPrice(response.data.previous_price || 0);

//     // Only set discount if coupon is NOT applied
//     if (!couponApply) {
//       setDiscount(response.data.discounted_price || 0);
//     }

//     // Only set delivery charge if pincode not validated yet
//     if (!pincodeValid && !selectedAddressPincodeValid) {
//       setDeliveryCharge(response.data.delivery_charge || 0);
//     }
//   } catch (error) {
//     console.error("Price error:", error);
//   }
// };

//   const applyCoupon = async () => {
//     try {
//       if (!couponCode) return toast.error("Enter coupon code");

//       const response = await Api.post("api/apply-coupon/", {
//         coupon_code: couponCode,
//         cart_value: baseTotal,
//       });

//       if (response.data.status === true) {
//         setDiscount(response.data.discount);
//         setCouponApply(true);
//         toast.success(response.data.message);
//       } else {
//         toast.error(response.data.message);
//       }

//       calculateFinalPrice();
//     } catch (error) {
//       console.error("Coupon error:", error);
//       toast.error("Invalid coupon");
//     }
//   };

//   const removeCoupon = () => {
//     setCouponApply(false);
//     setCouponCode("");
//     setDiscount(0);
//     calculateFinalPrice();
//     toast.info("Coupon removed");
//   };

//   const razorpayKeyId = "rzp_live_RYSfTyxfbAycrR";

//   const handlePayment = async () => {
//     if (deliveryOption === "delivery") {
//       if (!selectedAddressId) {
//         return alert("Please select a delivery address.");
//       }

//       const selectedAddress = addresses.find(
//         (addr) => addr.id === selectedAddressId
//       );

//       if (!selectedAddress || !selectedAddress.zip_code) {
//         return alert("Invalid address. Please check your delivery address.");
//       }

//       if (!selectedAddressPincodeValid) {
//         const isValid = await checkPincode(selectedAddress.zip_code, true);
//         if (!isValid) {
//           toast.error("Delivery not available for this pincode");
//           return;
//         }
//       }
//     }

//     const selectedAddress = addresses.find(
//       (addr) => addr.id === selectedAddressId
//     );
//     const priceBeforeWallet = previousPrice + deliveryCharge
//   + (paymentMethod !== "cod" ? transactionCharge : 0)
//   - discount;

// const effectiveWallet = walletValue > 0
//   ? (paymentMethod === "cod"
//       ? Math.min(walletValue, priceBeforeWallet)        // COD: can go to ₹0
//       : Math.min(walletValue, Math.max(0, priceBeforeWallet - 1))) // Online: min ₹1
//   : 0;
//     const pick_up = deliveryOption === "delivery" ? 0 : 1;
//     try {
//       const bodyData = {
//         user_id: uid,
//         total_amount: finalPrice,
//         newname: selectedAddress?.newname,
//         address: selectedAddress?.address,
//         city: selectedAddress?.city,
//         state: selectedAddress?.state,
//         country: selectedAddress?.country,
//         zip_code: selectedAddress?.zip_code,
//         phone: selectedAddress?.phone,
//         delivery_time: selectedOption ? selectedOption : selectedPickup,
//         coupon_code: couponCode,
//         // walet_value: walletValue,
//         walet_value: effectiveWallet,
//         delivery_price: deliveryCharge,
//         discounted_price: discount,
//         previous_price: previousPrice,
//         pick_up: pick_up,
//         payment_method: paymentMethod,
//         payment_option:
//           paymentOptions.find((opt) => opt.code === paymentMethod)?.id || "",
//       };

//       const response = await Api.post("api/create_order/", bodyData);

//       if (paymentMethod === "cod") {
//         navigate("/orderdone");
//         return;
//       }

//       const options = {
//         currency: "INR",
//         key: razorpayKeyId,
//         amount: finalPrice * 100,
//         name: "Frozenwala Cart",
//         order_id: response.data.razorpay_order_id,
//         handler: async function (res) {
//           await Api.post("api/verify_payment/", {
//             razorpay_payment_id: res.razorpay_payment_id,
//             razorpay_order_id: res.razorpay_order_id,
//             razorpay_signature: res.razorpay_signature,
//           });
//           navigate("/orderdone");
//         },
//       };

//       new Razorpay(options).open();
//     } catch (error) {
//       console.error("Payment error:", error);
//     }
//   };

//   // Fixed handleChange to prevent focus loss
//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target;
//     setAddressInfo((prev) => ({ ...prev, [name]: value }));
//   }, []);

//   const isPayButtonEnabled = () => {
//     if (deliveryOption === "delivery") {
//       if (!selectedAddressId) return false;
//       if (!selectedAddressPincodeValid) return false;
//       return true;
//     }
//     return true;
//   };

//   const handleAddNewAddress = () => {
//     setSelectedAddressId(null);
//     setSelectedAddressPincodeValid(false);
//     setShowAddressForm(true);
//     setIsEditing(false);
//     setEditingAddressId(null);
//     setShowEditModal(false);
//     setPincodeCheck("");
//     setPincodeValid(false);
//     setPincodeChecked(false);
//     setVerifiedPincode("");
//     setPincodeMessage("");
//     setAddressInfo({
//       name: "",
//       phone: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       zip: "",
//     });
//   };

//   const handleCheckAgain = () => {
//     setPincodeValid(false);
//     setPincodeChecked(false);
//     setVerifiedPincode("");
//     setPincodeMessage("");
//     setPincodeCheck("");
//   };

//   useEffect(() => {
//     setSelectedOption("Within 1hr");
//     setSelectedPickup("Within 1hr");
//   }, [deliveryOption]);

//   return (
//     <>
//       <Navbar />

//       <motion.div className="checkout-container">
//         <div className="checkout-left">
//           <div className="checkout-card">
//             <h3>Customer Details</h3>

//             <div className="option-buttons">
//               <button
//                 className={`option-btn ${deliveryOption === "delivery" ? "active" : ""}`}
//                 onClick={() => {
//                   setDeliveryOption("delivery");
//                   setPickup(0);
//                   getTotalPrice(0);
//                 }}
//               >
//                 Delivery
//               </button>

//               <button
//                 className={`option-btn ${deliveryOption === "pickup" ? "active" : ""}`}
//                 onClick={() => {
//                   setDeliveryOption("pickup");
//                   setPickup(1);
//                   getTotalPrice(1);
//                 }}
//               >
//                 Pickup
//               </button>
//             </div>

//             {deliveryOption === "delivery" && (
//               <div className="address-form">
//                 <div className="pincode-check-section">
//                   <h5>Check Delivery Availability</h5>
//                   <div className="pincode-input-group">
//                     <input
//                       type="text"
//                       placeholder="Enter 6-digit pincode"
//                       value={pincodeCheck}
//                       onChange={handlePincodeChange}
//                       maxLength="6"
//                       className="pincode-input"
//                       disabled={pincodeValid && !showAddressForm}
//                     />
//                     <button
//                       className="check-pincode-btn"
//                       onClick={handleManualPincodeCheck}
//                       disabled={
//                         pincodeLoading || (pincodeValid && !showAddressForm)
//                       }
//                     >
//                       {pincodeLoading ? "Checking..." : "Check"}
//                     </button>
//                   </div>

//                   {pincodeChecked && pincodeCheck.length === 6 && (
//                     <div
//                       className={`pincode-message ${pincodeValid ? "valid" : "invalid"}`}
//                     >
//                       {pincodeLoading ? (
//                         <span>Checking availability...</span>
//                       ) : pincodeValid ? (
//                         <span>
//                           ✓ {pincodeMessage} - Delivery charge:{" "}
//                           {formatDeliveryCharge(pincodeDeliveryCharge)}
//                         </span>
//                       ) : (
//                         <span>✗ {pincodeMessage}</span>
//                       )}
//                     </div>
//                   )}

//                   {pincodeValid && !showAddressForm && (
//                     <button
//                       className="proceed-address-btn"
//                       onClick={handleProceedToAddress}
//                     >
//                       Add New Address with this Pincode
//                     </button>
//                   )}
//                 </div>

//                 {/* EXISTING ADDRESSES WITH EDIT BUTTON */}
//                 {addresses && addresses.length > 0 && (
//                   <div className="existing-addresses-section">
//                     <h5>Select Existing Address</h5>
//                     <div className="addresses-list">
//                       {addresses.map((address) => (
//                         <div
//                           key={address.id}
//                           className={`address-card ${selectedAddressId === address.id ? "selected" : ""
//                             } ${selectedAddressId === address.id &&
//                               !selectedAddressPincodeValid
//                               ? "invalid-pincode"
//                               : ""
//                             }`}
//                         >
//                           <div className="address-radio">
//                             <input
//                               type="radio"
//                               name="address-selection"
//                               checked={selectedAddressId === address.id}
//                               onChange={() => handleSelectAddress(address)}
//                               disabled={checkingSelectedAddress}
//                             />
//                           </div>
//                           <div className="address-details">
//                             <p className="address-name">
//                               <strong>{address.newname}</strong>
//                             </p>
//                             <p className="address-phone">{address.phone}</p>
//                             <p className="address-text">
//                               {address.address}, {address.city}, {address.state}{" "}
//                               {address.zip_code}, {address.country}
//                             </p>
//                             {selectedAddressId === address.id &&
//                               checkingSelectedAddress && (
//                                 <p className="pincode-checking">
//                                   Checking pincode availability...
//                                 </p>
//                               )}
//                             {selectedAddressId === address.id &&
//                               selectedAddressPincodeValid && (
//                                 <p className="pincode-valid-msg">
//                                   ✓ Delivery available for this pincode
//                                 </p>
//                               )}
//                             {selectedAddressId === address.id &&
//                               !selectedAddressPincodeValid &&
//                               !checkingSelectedAddress && (
//                                 <p className="pincode-invalid-msg">
//                                   ✗ Delivery not available for pincode{" "}
//                                   {address.zip_code}
//                                 </p>
//                               )}
//                           </div>
//                           <div className="address-actions">
//                             <button
//                               className="edit-address-btn"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handleEditAddress(address);
//                               }}
//                               title="Edit Address"
//                             >
//                               ✏️ Edit
//                             </button>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {/* ALWAYS SHOW ADD NEW ADDRESS BUTTON */}
//                 <button
//                   className="add-new-address-btn"
//                   onClick={handleAddNewAddress}
//                 >
//                   + Add New Address
//                 </button>

//                 {/* ADDRESS FORM (ADD ONLY - EDIT USES MODAL) */}
//                 {showAddressForm && !isEditing && (
//                   <div className="new-address-form">
//                     <h5>
//                       Add Delivery Address
//                       {verifiedPincode ? ` for Pincode: ${verifiedPincode}` : ""}
//                     </h5>
//                     <div className="address-fields">
//                       <input
//                         type="text"
//                         name="name"
//                         placeholder="Full Name"
//                         value={addressInfo.name}
//                         onChange={handleChange}
//                       />
//                       <input
//                         type="tel"
//                         name="phone"
//                         placeholder="Phone Number"
//                         value={addressInfo.phone}
//                         onChange={handleChange}
//                       />
//                       <textarea
//                         name="address"
//                         placeholder="Address"
//                         value={addressInfo.address}
//                         onChange={handleChange}
//                         rows="2"
//                       />
//                       <input
//                         type="text"
//                         name="city"
//                         placeholder="City"
//                         value={addressInfo.city}
//                         onChange={handleChange}
//                       />
//                       <input
//                         type="text"
//                         name="state"
//                         placeholder="State"
//                         value={addressInfo.state}
//                         onChange={handleChange}
//                       />
//                       <input
//                         type="text"
//                         name="country"
//                         placeholder="Country"
//                         value={addressInfo.country}
//                         onChange={handleChange}
//                       />
//                       <input
//                         type="text"
//                         name="zip"
//                         placeholder="Pincode"
//                         value={addressInfo.zip}
//                         onChange={handleChange}
//                         disabled={!!verifiedPincode && !isEditing}
//                         className={
//                           verifiedPincode && !isEditing ? "disabled-input" : ""
//                         }
//                       />
//                     </div>

//                     <div className="address-form-buttons">
//                       <button
//                         className="save-address-btn"
//                         onClick={saveNewAddress}
//                       >
//                         Save Address
//                       </button>
//                       <button
//                         className="cancel-address-btn"
//                         onClick={() => {
//                           setShowAddressForm(false);
//                           setIsEditing(false);
//                           setEditingAddressId(null);
//                           setAddressInfo({
//                             name: "",
//                             phone: "",
//                             address: "",
//                             city: "",
//                             state: "",
//                             country: "",
//                             zip: "",
//                           });
//                         }}
//                       >
//                         Cancel
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {selectedAddressId && selectedAddressPincodeValid && (
//                   <>
//                     <div className="delivery-timing">
//                       <h5>Select Delivery Timing:</h5>
//                       <div className="timing-options">
//                         {["Within 1hr", "1-3 hrs"].map((time) => (
//                           <label key={time}>
//                             <input
//                               type="radio"
//                               checked={selectedOption === time}
//                               onChange={() => setSelectedOption(time)}
//                             />
//                             {time}
//                           </label>
//                         ))}
//                       </div>
//                     </div>

//                     {paymentOptions && paymentOptions?.length > 0 && (
//                       <div className="payment-method">
//                         <h5>Select Payment Method:</h5>
//                         <div className="payment-options">
//                           {paymentOptions.map((option) => (
//                             <label key={option.value}>
//                               <input
//                                 type="radio"
//                                 value={option.code}
//                                 checked={paymentMethod === option.code}
//                                 onChange={(e) => {
//                                   setPaymentMethod(e.target.value);
//                                   // setTimeout(() => {
//                                   //   calculateFinalPrice();
//                                   // }, 50);
//                                 }}
//                               />
//                               {option.display_name}
//                             </label>
//                           ))}
//                         </div>
//                       </div>
//                     )}
//                     {paymentOptions && paymentOptions?.length > 0 && (
//                       <button
//                         className="pay-btn"
//                         onClick={handlePayment}
//                         disabled={!isPayButtonEnabled()}
//                       >
//                         {paymentMethod === "cod"
//                           ? "Place Order (COD)"
//                           : "Proceed to Pay"}
//                       </button>
//                     )}
//                   </>
//                 )}
//               </div>
//             )}

//             {deliveryOption === "pickup" && (
//               <div className="pickup-form">
//                 <h5>Select Pickup Timing</h5>
//                 <div className="pickup-timing">
//                   {["Within 1hr", "1hr–3hrs"].map((time) => (
//                     <label key={time}>
//                       <input
//                         type="radio"
//                         checked={selectedPickup === time}
//                         onChange={() => setSelectedPickup(time)}
//                       />
//                       {time}
//                     </label>
//                   ))}
//                 </div>
//                 {paymentOptions && paymentOptions?.length > 0 && (
//                   <div className="payment-method">
//                     <h5>Select Payment Method:</h5>
//                     <div className="payment-options">
//                       {paymentOptions.map((option) => (
//                         <label key={option.value}>
//                           <input
//                             type="radio"
//                             value={option.code}
//                             checked={paymentMethod === option.code}
//                             onChange={(e) => setPaymentMethod(e.target.value)}
//                           />
//                           {option.display_name}
//                         </label>
//                       ))}
//                     </div>
//                   </div>
//                 )}

//                 {paymentOptions && paymentOptions?.length > 0 && (
//                   <button className="pay-btn" onClick={handlePayment}>
//                     {paymentMethod === "cod"
//                       ? "Place Order (COD)"
//                       : "Proceed to Pay"}
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="checkout-right">
//           <h3>Items</h3>

//           {getProduct?.map((item) => (
//             <div className="item-card" key={item.id}>
//               <div className="item-info">
//                 <img src={item.product_image || logo} alt={item.product_name} />
//                 <div>
//                   <span className="item-name">{item.product_name}</span>
//                   <p>₹{item.price}</p>
//                 </div>
//               </div>
//               <span>Qty {item.quantity}</span>
//             </div>
//           ))}

//           <div className="price-summary">
//             <div className="available-coupons-section">
//               <h4>Available Coupon Offers</h4>
//               {loadingCoupons ? (
//                 <div className="coupon-loading">Loading offers...</div>
//               ) : availableCoupons.length > 0 ? (
//                 <div className="coupon-cards-container">
//                   {availableCoupons.map((coupon, index) => (
//                     <div
//                       className="coupon-card"
//                       key={index}
//                       onClick={() => {
//                         setCouponCode(coupon.coupon);
//                         toast.info(
//                           `Coupon ${coupon.coupon} copied! Click Apply to use.`
//                         );
//                       }}
//                     >
//                       <div className="coupon-header">
//                         <span className="coupon-code">{coupon.coupon}</span>
//                         <span className="coupon-badge">
//                           {coupon.coupon_type === "Flat" ? "₹" : "%"}
//                         </span>
//                       </div>
//                       <div className="coupon-body">
//                         <p className="coupon-value">
//                           {coupon.coupon_type === "Flat"
//                             ? `₹${coupon.coupon_value} OFF`
//                             : `${coupon.coupon_value}% OFF`}
//                         </p>
//                         <p className="coupon-minimum">
//                           Min. purchase: ₹{coupon.minimum_purchase}
//                         </p>
//                       </div>
//                       <div className="coupon-footer">
//                         <p className="coupon-description">
//                           {coupon.description}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="no-coupons">
//                   No offers available at the moment
//                 </div>
//               )}

//               <p className="coupon-hint">
//                 👆 Click on any coupon to copy, then click Apply
//               </p>
//             </div>

//             <div className="purchase-benefits-section">
//               <h4>Purchase Benefits</h4>
//               {loadingBenefits ? (
//                 <div className="benefit-loading">Loading benefits...</div>
//               ) : purchaseBenefits.length > 0 ? (
//                 <div className="benefit-cards-container">
//                   {purchaseBenefits.map((benefit, index) => (
//                     <div className="benefit-card" key={benefit.id}>
//                       <div className="benefit-header">
//                         <span className="benefit-title">
//                           Spend ₹{benefit.price}
//                         </span>
//                         <span className="benefit-badge">
//                           {benefit.benefit_percentage}%
//                         </span>
//                       </div>
//                       <div className="benefit-body">
//                         <p className="benefit-description">
//                           Get {benefit.benefit_percentage}% benefit on your
//                           purchase
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="no-benefits">
//                   No purchase benefits available at the moment
//                 </div>
//               )}
//             </div>

//             <div className="coupon-input-section">
//               <input
//                 type="text"
//                 placeholder="Enter Coupon Code"
//                 value={couponCode}
//                 onChange={(e) => setCouponCode(e.target.value)}
//                 className="coupon-input"
//               />
//               {couponApply ? (
//                 <button onClick={removeCoupon} className="apply-btn remove-btn">
//                   Remove
//                 </button>
//               ) : (
//                 <button onClick={applyCoupon} className="apply-btn">
//                   Apply Coupon
//                 </button>
//               )}
//             </div>

//             <div className="summary-row">
//               <p>Wallet Balance: ₹{walletBalance.toFixed(2)}</p>
//               <label className="switch">
//                 <input
//                   type="checkbox"
//                   checked={walletValue > 0}
//                   onChange={(e) => {
//                     if (e.target.checked) {
//                       setWalletValue(walletBalance);
//                     } else {
//                       setWalletValue(0);
//                     }
//                   }}
//                 />
//                 <span className="slider"></span>
//               </label>
//             </div>

//             <div className="summary-card">
//               <h4 className="summary-title">Price Summary</h4>

//               <div className="summary-row">
//                 <span>Total Items Price (incl GST)</span>
//                 <span>₹{previousPrice}</span>
//               </div>

//               {gstPercentage > 0 && (
//                 <>
//                   <div className="summary-row">
//                     <span>CGST ({gstPercentage / 2}%)</span>
//                     <span>₹{cgstAmount}</span>
//                   </div>

//                   <div className="summary-row">
//                     <span>SGST ({gstPercentage / 2}%)</span>
//                     <span>₹{sgstAmount}</span>
//                   </div>

//                   <div className="summary-row">
//                     <span>Total GST({gstPercentage}%)</span>
//                     <span>₹{totalGstAmount}</span>
//                   </div>

//                   <div className="summary-divider" />
//                 </>
//               )}

//               <div className="summary-row">
//                 <span>Delivery</span>
//                 <span>₹{deliveryCharge}</span>
//               </div>

//               {paymentMethod !== "cod" && (
//                 <div className="summary-row">
//                   <span>Transaction</span>
//                   <span>₹{transactionCharge}</span>
//                 </div>
//               )}

//               <div className="summary-row discount">
//                 <span>Discount</span>
//                 <span>- ₹{discount}</span>
//               </div>

//               <div className="summary-row wallet">
//                 <span>Wallet Used</span>
//                 {/* <span>- ₹{walletValue}</span> */}
//                 <span>- ₹{effectiveWalletUsed}</span>
//               </div>

//               <div className="summary-divider" />

//               <div className="summary-total">
//                 <span>Grand Total</span>
//                 <span>₹{finalPrice.toFixed(2)}</span>
//               </div>

//               {paymentMethod === "cod" ? (
//                 <p className="summary-note" style={{ color: "#4CAF50" }}>
//                   ✓ No transaction fee applied for Cash on Delivery
//                 </p>
//               ) : (
//                 <p className="summary-note">
//                   * Transaction fee includes payment gateway charges
//                 </p>
//               )}

//               <p className="summary-note">
//                 All prices are inclusive of applicable taxes.
//               </p>
//             </div>
//           </div>
//         </div>
//       </motion.div>

//       {/* =====================================================
//           EDIT ADDRESS MODAL — Inlined to prevent focus loss.
//           DO NOT convert this back into a sub-component or
//           useCallback component; doing so causes React to
//           unmount/remount the inputs on every keystroke.
//          ===================================================== */}
//       {showEditModal && (
//         <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
//           <div
//             className="modal-content"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header">
//               <h3>Edit Delivery Address</h3>
//               <button
//                 className="modal-close"
//                 onClick={() => setShowEditModal(false)}
//               >
//                 &times;
//               </button>
//             </div>

//             <div className="modal-body">
//               <div className="address-fields">
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Full Name"
//                   value={addressInfo.name}
//                   onChange={handleChange}
//                 />
//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Phone Number"
//                   value={addressInfo.phone}
//                   onChange={handleChange}
//                 />
//                 <textarea
//                   name="address"
//                   placeholder="Address"
//                   value={addressInfo.address}
//                   onChange={handleChange}
//                   rows="2"
//                 />
//                 <input
//                   type="text"
//                   name="city"
//                   placeholder="City"
//                   value={addressInfo.city}
//                   onChange={handleChange}
//                 />
//                 <input
//                   type="text"
//                   name="state"
//                   placeholder="State"
//                   value={addressInfo.state}
//                   onChange={handleChange}
//                 />
//                 <input
//                   type="text"
//                   name="country"
//                   placeholder="Country"
//                   value={addressInfo.country}
//                   onChange={handleChange}
//                 />
//                 <input
//                   type="text"
//                   name="zip"
//                   placeholder="Pincode"
//                   value={addressInfo.zip}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 className="cancel-address-btn"
//                 onClick={() => setShowEditModal(false)}
//               >
//                 Cancel
//               </button>
//               <button className="save-address-btn" onClick={updateAddress}>
//                 Update Address
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <Footer />
//     </>
//   );
// };

// export default CheckoutPage;